<template>
  <section>
    <div class="div" ref="div1"></div>
    <center>
      <div style="height: 50px"></div>
    </center>

    <v-container fluid>      
      <v-row dense>
          <v-col>
              <v-container fluid >                
                <v-row dense>
                  <v-col cols="12" sm="6" md="6">    
                    <v-select
                      ref="input_sensor"
                      label="Sensor"
                      prepend-icon="mdi-chip"
                      :items="sensores"
                      :hint="sensorhint"
                      persistent-hint
                      v-model="sensorFiltro">
                      <template v-slot:prepend>
                        <v-icon>mdi-chip</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-select
                      label="Tipo de Alerta"
                      prepend-icon="mdi-alarm-light"
                      :items="tiposAlerta"
                      v-model="tipoAlerta">
                      <template v-slot:prepend>
                        <v-icon>mdi-alarm-light</v-icon>
                      </template>
                    </v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="2">
                    <v-menu
                      v-model="fromDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="computedDateFromFormatted"
                          label="Desde el"
                          autocomplete="off"
                          hint="Formato DD/MM/YYYY"
                          persistent-hint
                          readonly
                          prepend-icon="mdi-calendar"
                          @blur="date = parseDate(dateFromFormatted)"
                          v-on="on">
                        <template v-slot:prepend>
                          <v-icon :color="getValidIntervalColor()">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                      </template>
                      <v-date-picker
                        locale="es"
                        v-model="fromDateVal"
                        no-title
                        clearable
                        @input="fromDateMenu = false"
                      >
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $nextTick(() => {
                              fromDateVal = '';
                              fromDateMenu = false;
                            })
                          "
                          >Borrar</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" sm="6" md="2">
                    <v-menu
                      v-model="toDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="computedDateToFormatted"
                          label="Hasta el"
                          autocomplete="off"
                          hint="Formato DD/MM/YYYY"
                          persistent-hint
                          readonly
                          prepend-icon="mdi-calendar"
                          @blur="date = parseDate(dateToFormatted)"
                          v-on="on">
                          <template v-slot:prepend>
                            <v-icon :color="getValidIntervalColor()">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>

                      <v-date-picker
                        locale="es"
                        v-model="toDateVal"
                        no-title
                        @input="toDateMenu = false"
                      >
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $nextTick(() => {
                              toDateVal = '';
                              toDateMenu = false;
                            })
                          "
                          >Borrar</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                
                <v-row dense justify='end'>
                  <v-col cols="auto">
                    <v-btn :disabled="!getValidInterval()" color="green accent-4" style="height:50px" small dark class="ml-1" @click="buscarClick()"><v-icon>mdi-filter</v-icon>Aplicar</v-btn>
                  </v-col>
                </v-row>
              </v-container>
        </v-col>
      </v-row>

      <v-row dense v-if="needRefresh">
        <v-col align="center" class="text-xs-center" style="margin: 0 12px 0 12px">
          <v-alert color="indigo" dark border="left" icon="mdi-information" transition="slide-y-transition">Establezca filtros y pulse 'Aplicar'</v-alert>
        </v-col>
      </v-row>

      <v-row fluid v-if="!needRefresh">
        <v-col>
          <v-data-table mt5
            class="elevation-2 silver"
            ref="alertTable"
            :headers="showHeaders"
            :items="alertas"
            :search="buscar"
            :footer-props2="{ 'items-per-page-options': [5, 15, 30, 50] }"
            :options="options"
            :item-class="row_classes"
            hide-default-footer
            :footer-props="{
              showFirstLastPage: false, 
              firstIcon: 'mdi-arrow-left',
              lastIcon: 'mdi-arrow-right',
              itemsPerPageText: 'Filas por página: ',
              pageText: '',
            }">

            <template v-slot:top>
              <v-row dense class="pt-2 px-3">
                <v-col cols="11" sm="11">
                  <v-icon color="#E57373" class="lighten-4">mdi-alarm-light</v-icon>
                  <span class="mx-1" color="red" style="color: silver">Alertas (</span>{{ dataCount }}<span class="mx-1" color="red" style="color: silver">)</span>
                  <v-row v-if="totalPaginas>0" dense class="ml-3">
                    <span class="mx-4" style="font-size: 9px; color: gray; font-style: italic">Mostando página 
                       <span style="color: white">{{ dataPagina+1 }}</span>
                       de 
                       <span style="color: white">{{ totalPaginas }}</span>
                    </span>
                  </v-row>
                </v-col>
                <v-col dense pt-2 cols="auto" align="right">
                  <v-btn :disabled="dataPagina==0" color="deep-purple accent-4" x-small fab dark @click="progreso(-1, true)"><v-icon>mdi-page-first</v-icon></v-btn>
                  <v-btn :disabled="dataPagina==0" color="deep-purple accent-4" x-small fab dark class="ml-1" @click="progreso(-1, false)"><v-icon>mdi-chevron-left</v-icon></v-btn>
                  <v-btn :disabled="dataEof" color="deep-purple accent-4" x-small fab dark class="ml-1" @click="progreso(+1, false)"><v-icon>mdi-chevron-right</v-icon></v-btn>
                  <v-btn :disabled="dataEof" color="deep-purple accent-4" x-small fab dark class="ml-1" @click="progreso(+1, true)"><v-icon>mdi-page-last</v-icon></v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.enviadoEmail="{ item }">
             <td>
                <v-icon small :style="item.enviadoEmail ? 'color: white' : 'color: #333333'">mdi-email-outline</v-icon>
              </td>
             <td>
                <v-icon small :style="item.enviadaNotificacion ? 'color: yellow' : 'color: #333333'">mdi-bell-outline</v-icon>
              </td>
            </template>           

            <template v-slot:item.fechahora="{item}">
              <td :class="{'normal': true}">
              {{ fechaHoraSQLaFormatoLocal (item.fechahora) }}
              </td> 
            </template>

            <template v-slot:item.sensor="{item}">
              <td :class="{'marked': esNuevaAlerta(item)}">{{ item.sensor }}</td> 
            </template>
            
            <template v-slot:item.descripcion_alerta="{item}">
              <td :class="{'normal': true}">{{ item.descripcion_alerta }}</td> 
            </template>
          </v-data-table>
        </v-col>        
      </v-row>
    </v-container>


    <v-dialog v-model="cuadroEmergente.mostrar" max-width="400">
        <v-card light>
          <v-card-title class="headline"><v-icon color="#303030" x-large class="mr-2" v-html="cuadroEmergente.icono"></v-icon><span v-html="cuadroEmergente.titulo"></span></v-card-title>
          <v-card-text><span v-html="cuadroEmergente.texto"></span></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="cuadroEmergente.accion()">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </section>
</template>

<script>
import api from "@/api";
import { DateTime } from "luxon";

export default {
  name: "Alertas",
  data() {
    return {
      off: new Date().getTimezoneOffset()*60*1000,
      msDay: 24 * 60 * 60 * 1000,
      options: {
        itemsPerPage: 15,
      },
      orden: 'DESC',

      cuadroEmergente: {
        mostrar: false,
        titulo: "",
        texto: ""
      },

      buscar: "",
      buscarEnDescripcion: "",
      sensorhint: "",
      dateFromFormatted: "",
      dateToFormatted: "",

      fromDateMenu: false,
      fromDateVal: null,
      toDateMenu: false,
      toDateVal: null,

      alertas: [],
      ultimaConsultaAlertas: null,

      sensores: [],
      sensorFiltro: "",

      tiposAlerta: ["(sin filtro)", "Temperatura", "Humedad", "Puerta Abierta", "Conexión"],
      tipoAlerta: "",
      tipoAlertaIndex: 0,

      dataPagina: 0,
      totalPaginas: 0,
      dataCursor: 0,
      dataCount: 0,
      dataEof: false,

      headers: [],
      selectedHeaders: null,
      cabeceras: [
        {
          name: "pepex",
          text: "Fecha/Hora",
          value: "fechahora",
          width: "10%",
          sortable: false,
          class: ["darken-2"],
        },
        {
          text: "Sensor",
          align: "start",
          value: "sensor",
          sortable: false,
          width: "30%",
        },
        {
          text: "Tipo de Alerta",
          value: "tipo_alerta",
          width: "10%",
          sortable: false,
          shown: false,
        },
        {
          text: "Descripción de la Alerta",
          value: "descripcion_alerta",
          width: "38%",
          sortable: false,
          shown: false,
        },
        {
          text: "",
          value: "enviadoEmail",
          width: "2%",
          sortable: false,
          
        },
      ],

      tipoHidden: false,
      mounting: false,
      needRefresh: true,
      noData: true
    };
  },

  created() {
    this.headers = Object.values(this.cabeceras);
    this.selectedHeaders = this.headers;
  },

  methods: {
   
    getValidInterval() {
      return this.fromDateVal<=this.toDateVal;
    },

    getValidIntervalColor() {
      return this.getValidInterval() ? "white" : "red";
    },

    esNuevaAlerta(item) {
      return (DateTime.fromSQL (item.fechahora).toMillis() > this.ultimaConsultaAlertas)
    },

    progreso(avance, tolimit) {
      if (!tolimit) this.dataPagina += avance;
      else if (avance==-1) this.dataPagina=0;
           else this.dataPagina=Math.trunc((this.dataCount-1) / this.options.itemsPerPage);
      this.cargaGrid();
    },
    
    buscarClick() {
      this.dataPagina = 0;
      this.cargaGrid();
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${day.padStart(2, "0")}-${month.padStart(2, "0")}`;
    },

    fechaHoraSQLaFormatoLocal (fechahoraSQL) {   
      return DateTime.fromSQL (fechahoraSQL).toLocaleString (DateTime.TIME_ONLY)+" "+new Date(DateTime.fromSQL(fechahoraSQL)).toLocaleTimeString('es-ES')
    },

    row_classes() {      
      return "";
    },

    closePicker() {
      this.$nextTick(() => {
        this.fromDateVal = "";
        this.fromDateMenu = false;
      });
    },

    estadoSensores() {
      this.$global.cargando = true;
      api
        .estadoSensores()
        .then((r) => {
          this.sensores = [];
          this.sensorFiltro = "";
            this.sensores.push ({
              value: "",
              text: "(sin filtro)",
              localizacion: ""
            })
          r.data.sensores.forEach((e) => {
            this.sensores.push ({
              value: e.idSensor,
              text: e.descripcion,
              localizacion: e.localizacion
            })
          });          
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.$global.cargando = false;
        });
    },

    cargaGrid() {
      if (this.mounting) return;

      let manejador;
      this.dataPagina = this.dataPagina<0 ? 0 : this.dataPagina;
      manejador = setTimeout (() => { this.$global.cargando = true; }, 500);
      var len=0;
      api.alertasUsuario(
          this.sensorFiltro,
          this.tipoAlertaIndex-1,
          new Date(DateTime.fromSQL(this.fromDateVal).toMillis() - this.off).toISOString(),
          new Date(DateTime.fromSQL(this.toDateVal).toMillis() - this.off + this.msDay - 1000).toISOString(),
          this.buscarEnDescripcion,
          this.dataPagina*this.options.itemsPerPage,
          this.options.itemsPerPage,
          this.orden
        )
        .then((r) => {
          this.dataCount = r.data.count;
          this.totalPaginas = Math.trunc((this.dataCount-1) / this.options.itemsPerPage)+1;
          this.dataEof = ((this.dataPagina)*this.options.itemsPerPage) >= this.dataCount;
          this.dataEof = (this.dataPagina+1)>=this.totalPaginas;
          this.alertas = r.data.sensores;
          len=this.alertas.length;
        })
        .catch((e) => {
          this.alertas = [];
          this.totalPaginas = 0;
          console.log(e);

          this.cuadroEmergente.icono = "mdi-emoticon-confused-outline";
          this.cuadroEmergente.titulo = "Se ha producido un error";
          this.cuadroEmergente.texto = "No se han podido obtener los datos solicitados.<br><span style='font-style:italic; font-size:12px'>Razón:</span>&nbsp;<span style='color:red;  font-size:12px'>Tiempo de espera excedido";
          this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false };
          this.cuadroEmergente.mostrar = true;
        })
        .finally(() => {
          this.dataCursor+=len;
          clearTimeout (manejador);
          this.$global.cargando = false;
          this.needRefresh = false;
          this.noData = len==0;
        });
    },

    realHeaders() {
      let realHeaders = this.cabeceras.slice(); // array copy

      this.tipoHidden = this.tipoAlertaIndex != 0;
      if (this.tipoHidden) {
        realHeaders.splice(2, 1);
      }
      this.headers = Object.values(realHeaders);
      this.selectedHeaders = this.headers;
    },

    clearGrid() {
      this.alertas = [];
      this.dataPagina=0;
      this.dataCount = 0;
      this.totalPaginas = 0;
      this.dataEof = true;
    }
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(val);
    },

    sensorFiltro: function () {
      this.sensorhint = '';
      // saco la descripcion del Sensor para el "hint" ...
      let res = this.sensores.filter((sensor) => {
        return sensor.value == this.sensorFiltro;
      });
      if (res.length>0) this.sensorhint = res[0].localizacion;
      this.realHeaders();
      this.needRefresh = true
    },
    tipoAlerta: function () {
      this.tipoAlertaIndex = 0;
      this.tiposAlerta.forEach((tipo, index) =>
        tipo === this.tipoAlerta ? (this.tipoAlertaIndex = index) : 0
      );      
      this.realHeaders();
      this.needRefresh = true
    },

    fromDateVal: function () {
      this.needRefresh = true
    },
    toDateVal: function () {
      this.needRefresh = true
    },
  },

  computed: {
    computedDateFromFormatted() {
      return this.formatDate(this.fromDateVal);
    },
    computedDateToFormatted() {
      return this.formatDate(this.toDateVal);
    },

    showHeaders() {
      return this.headers.filter((s) => this.selectedHeaders.includes(s));
    },
  },

  mounted() {
    
    api.inicializarNotificacionesAlertas()
      .then ((respuesta) => {
        this.ultimaConsultaAlertas = DateTime.fromSQL (respuesta.data.ultimaConsultaAlertas).toMillis();
      }).finally(() => {
        this.mounting = true;
        this.orden = 'DESC';
        this.sensorhint = '';
        this.estadoSensores();
        this.fromDateVal =  new Date().toISOString().slice(0, 10);
        if (this.$global.numeroAlertasPendientesDesde!=null) {
          this.fromDateVal = new Date(this.$global.numeroAlertasPendientesDesde.substr(0, 10)).toISOString().substr(0, 10);
        }
        this.toDateVal =  new Date().toISOString().slice(0, 10);
        this.tipoAlerta = this.tiposAlerta[0];
        this.$nextTick(() => {    
          this.$refs.input_sensor.focus();
        });
        this.mounting = false;
        this.cargaGrid(); 
      });       
  },
};
</script>
 
<style>
html { overflow-y: auto } 

.marked {
  color: rgb(252, 236, 184);
  font-style: bold;
}

.normal {
  font-style: normal;
  font-size: 13px;
}

.monosp {
    font-family: 'Courier', monospace;
    color: gray;
}
</style>

